import { capitalize } from '../utils/Utils'
import { css, StyleSheet } from 'aphrodite'
import { COLOR_GREEN, COLOR_WARNING } from '../lib/colors'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  status: {
    borderRadius: '50%',
    width: '10px',
    height: '10px',
    marginRight: '15px',
  },
  green: {
    backgroundColor: COLOR_GREEN,
  },
  red: {
    backgroundColor: COLOR_WARNING,
  },
})

const NEW = 'NEW'
const AVAILABLE = 'AVAILABLE'
const ACCEPTED = 'ACCEPTED'
const FLAGGED = 'FLAGGED'
const REJECTED = 'REJECTED'
const OUTDATED = 'OUTDATED'
const OVER = 'OVER'
const LIVE = 'LIVE'
const CANCELED = 'CANCELED'
const OUTDATED_UNPAID = 'OUTDATED_UNPAID'

const statusWithIcon = (status, renderedStatus) => {
  return (
    <div className={css(styles.container)}>
      <div
        className={css(
          styles.status,
          status === FLAGGED ||
            REJECTED ||
            OUTDATED_UNPAID ||
            CANCELED ||
            OUTDATED ||
            OVER
            ? styles.red
            : status === LIVE || NEW || AVAILABLE || ACCEPTED
            ? styles.green
            : null
        )}
      ></div>
      {renderedStatus ? renderedStatus : capitalize(status)}
    </div>
  )
}

export {
  NEW,
  OUTDATED_UNPAID,
  AVAILABLE,
  ACCEPTED,
  FLAGGED,
  REJECTED,
  OUTDATED,
  OVER,
  LIVE,
  CANCELED,
  statusWithIcon,
}
